import {
  PermissionValues,
  useCurrentAccount,
  useIsInImpersonateUser,
  useLogout,
} from '@gripp/shared-logic';
import {
  AdminImpersonateUser,
  ProfileForm,
  ProfileOptions,
  SaveFormBottomOld as SaveForm,
  Spacing,
  useProfileForm,
  useSlideLayout,
} from '@gripp/shared-ui';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { MediaPicker } from '../../../shared/components/media/mediaPicker';
import { getMediaBaseUrl } from '../../../shared/mediaUtils';

export const SettingsProfile = () => {
  const { setColumnTitle } = useSlideLayout();
  const mediaUrl = getMediaBaseUrl();
  const { t } = useTranslation();
  const { account } = useCurrentAccount();
  const navigate = useNavigate();
  const logout = useLogout();
  const isInImpersonateUser = useIsInImpersonateUser();
  const {
    control,
    handleSubmit,
    formState: { isValid, isDirty },
  } = useProfileForm();

  const isGlobalAdmin = useCallback(() => {
    return account && account.hasPermission(PermissionValues.globalAdmin);
  }, [account]);

  const onNavigate = (path: string) => {
    navigate(`/${path}`);
  };

  const onLogout = () => {
    logout().then(() => {
      navigate('/');
    });
  };
  
  useEffect(() => {
    setColumnTitle(t('preferences.settings.profile'));
  }, [setColumnTitle, t]);

  return (
    <ScrollView
      contentContainerStyle={styles.contentContainer}
      scrollEnabled={true}
      showsVerticalScrollIndicator={true}
    >
      <SaveForm
        title={t('avatar.menu.profile')}
        onSubmit={handleSubmit}
        isDirty={isDirty}
        isValid={isValid}
        hasBorder={true}
      >
        <ProfileForm
          control={control}
          mediaUrl={mediaUrl}
          imagePicker={MediaPicker}
          inputMaxWidth={322}
        />
      </SaveForm>
      {(isGlobalAdmin() || !!isInImpersonateUser) && (
        <View style={styles.workspacePicker}>
          <AdminImpersonateUser />
        </View>
      )}
      <ProfileOptions onNavigate={onNavigate} onLogout={onLogout} />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
    paddingVertical: Spacing.basePadding.paddingVertical,
    paddingHorizontal: Spacing.basePadding.paddingHorizontal,
  },
  workspacePicker: {
    marginTop: 8,
  },
});
